var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg000Nein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496.158,
    height: 496.158,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 324.721,
    width: 324.721,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_18"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    fill: "#e3e8ee",
    d: "m454.117488,248.083896c0,-111.630429 -92.247606,-202.111355 -206.035987,-202.111355c-113.793364,0 -206.04097,90.480112 -206.04097,202.111355c0,111.614949 92.247606,202.101579 206.04097,202.101579c113.788381,0 206.035987,-90.486629 206.035987,-202.101579z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    fill: "#777f8e",
    d: "m272.133817,248.081452l60.237097,-68.594125c6.569538,-7.480537 5.710764,-18.771405 -1.918538,-25.215649c-7.617674,-6.439355 -19.128899,-5.601848 -25.70259,1.878688l-56.672437,64.533681l-56.666624,-64.533681c-6.569538,-7.485425 -18.081594,-8.322932 -25.708404,-1.878688c-7.629301,6.444244 -8.483092,17.735927 -1.913554,25.215649l60.232114,68.594125l-60.232114,68.590866c-6.569538,7.480537 -5.715747,18.771405 1.913554,25.215649c3.44091,2.907649 7.674981,4.332552 11.88995,4.332552c5.116931,0 10.210607,-2.106803 13.818454,-6.211241l56.666624,-64.533681l56.672437,64.533681c3.602864,4.106881 8.695709,6.211241 13.817623,6.211241c4.209986,0 8.444887,-1.424903 11.885797,-4.332552c7.629301,-6.444244 8.488075,-17.735927 1.918538,-25.215649l-60.237927,-68.590866z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg000Nein);
export default __webpack_public_path__ + "static/media/000 Nein.08010a3d0640b5c91a1b7b7f8892edf4.svg";
export { ForwardRef as ReactComponent };